import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Auth from "../pages/auth/Auth";
import DefaultLayout from "../layouts/index";
import NutritionRecipes from "../pages/nutrition/Recipe/NutritionRecipes";
import AddEditRecipe from "../pages/nutrition/Recipe/AddEditRecipe";
import NutritionTips from "../pages/nutrition/tips/NutritionTips";
import AddEditTip from "../pages/nutrition/tips/AddEditTip";
import Movement from "../pages/movement/Movement";
import AddEditMovement from "../pages/movement/AddEditMovement";
import CommunalGarden from "../pages/communalgarden/CommunalGarden";
import AddEditCommunalGarden from "../pages/communalgarden/AddEditCommunalGarden";
import Audio from "../pages/audio/Audio";
import AddEditAudio from "../pages/audio/AddEditAudio";
import Affirmations from "../pages/affirmation/Affirmations";
import AddEditAffirmation from "../pages/affirmation/AddEditAffirmation";
import User from "../pages/user/User";
import EditUser from "../pages/user/EditUser";
import ViewUser from "../pages/user/ViewUser";
import Video from "../pages/video/Video";
import AddEditVideo from "../pages/video/AddEditVideo";
import Profile from "../pages/profile/Profile";
import ResetPassword from "../pages/auth/ResetPassword";
import NewPassword from "../pages/auth/NewPassword";
import PasswordSuccessful from "../pages/auth/PasswordSuccessful";
import OtpVerify from "../pages/auth/OtpVerify";
import Notification from "../pages/notification/Notification";
import AddNotification from "../pages/notification/AddNotification";
import UserTester from "../pages/tester/UserTester";
import EditUserTester from "../pages/tester/EditUserTester";
import Subscription from "../pages/tester/Subscription";
import Section from "../pages/section/Section";
import AddEditSection from "../pages/section/AddEditSection";

const AppRoutes = () => {
  return (
    <>
      <ToastContainer position="bottom-right" theme="colored" />
      <Routes>
        {/* Auth */}
        <Route exact path="/login" element={<Auth />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/new-password" element={<NewPassword />} />
        <Route path="/otp" element={<OtpVerify />} />
        <Route path="/success-password" element={<PasswordSuccessful />} />

        {/* DefaultLayout */}
        <Route path="/" element={<DefaultLayout />}>
          <Route index exact element={<User />} />
          {/* Nutrition */}
          <Route path="/nutrition-recipes" element={<NutritionRecipes />} />
          <Route path="/add-edit-recipe" element={<AddEditRecipe />} />
          <Route path="/nutrition-tips" element={<NutritionTips />} />
          <Route path="/add-edit-tip" element={<AddEditTip />} />

          {/* movement */}
          <Route path="/movement" element={<Movement />} />
          <Route path="/add-edit-movement" element={<AddEditMovement />} />

          {/* Communal garden */}
          <Route path="/communal-garden" element={<CommunalGarden />} />
          <Route
            path="/add-edit-communal-garden"
            element={<AddEditCommunalGarden />}
          />

          {/* Audio */}
          <Route path="/audio" element={<Audio />} />
          <Route path="/add-edit-audio" element={<AddEditAudio />} />

          {/* Video */}
          <Route path="/video" element={<Video />} />
          <Route path="/add-edit-video" element={<AddEditVideo />} />

          {/* Affirmations */}
          <Route path="/affirmations" element={<Affirmations />} />
          <Route
            path="/add-edit-affirmation"
            element={<AddEditAffirmation />}
          />
          {/* profile */}
          <Route path="/profile" element={<Profile />} />
          {/* user */}
          <Route path="/edit-user" element={<EditUser />} />
          <Route path="/view-user/:id" element={<ViewUser />} />
          {/* Push Notification */}
          <Route path="/push-notification" element={<Notification />} />
          <Route path="/add-notification" element={<AddNotification />} />

          {/* user tester */}
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/user-tester" element={<UserTester />} />
          <Route path="/edit-tester" element={<EditUserTester />} />

          {/* Section Management */}
          <Route path="/section" element={<Section />} />
          <Route path="/add-edit-section" element={<AddEditSection />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoutes;
